import * as angular from "angular";

export class ToastUtils {
    private readonly $mdToast: any;
    private readonly __app_type: string;
    public toast: any;

    constructor($mdToast: any, __app_type: string) {
        this.$mdToast = $mdToast;
        this.__app_type = __app_type;
    }

    error(error?: any, hideDelay?: number): any {
        let errorMessage = "";
        if (typeof error === "string" || error instanceof String) {
            errorMessage = error.toString();
        } else if (
            error &&
            error.message &&
            (typeof error.message === "string" ||
                error.message instanceof String)
        ) {
            errorMessage = error.message;
        } else if (
            error &&
            error.data &&
            error.data.error &&
            error.data.error.message &&
            (typeof error.data.error.message === "string" ||
                error.data.error.message instanceof String)
        ) {
            errorMessage = error.data.error.message;
        } else if (
            error &&
            error.data &&
            error.data &&
            error.data.data &&
            error.data.data.message &&
            error.data.data.message[0] &&
            (typeof error.data.data.message[0] === "string" ||
                error.data.data.message[0] instanceof String)
        ) {
            errorMessage = error.data.data.message[0].toString();
        } else {
            if (this.__app_type === "ADMIN") {
                errorMessage = "Sorry, an error has occurred.";
            } else {
                errorMessage =
                    "Sorry, an error has occurred. Please try again or contact support.";
            }
        }
        this.toast = this.$mdToast.show({
            template:
                '<md-toast class="md-toast md-error-toast-theme">' +
                "<p>" +
                errorMessage +
                "</p>" +
                "</md-toast>",
            hideDelay: hideDelay ? hideDelay : 6000,
            position: "bottom left",
        });
        return this.toast;
    }

    success(
        text: string,
        delay?,
        actionText?: string,
        className?: string,
        position?: string
    ): any {
        let delayInMs = delay ?? 5000;
        let toast = this.$mdToast
            .simple()
            .position(position ?? "bottom left")
            .textContent(text)
            .hideDelay(delayInMs);
        if (actionText) {
            delayInMs = delay ?? 10000;
            toast = this.$mdToast
                .simple()
                .textContent(text)
                .action(actionText)
                .hideDelay(delayInMs)
                .toastClass(className);
        }

        this.toast = this.$mdToast.show(toast);
        return this.toast;
    }

    hide(): void {
        this.$mdToast.hide();
    }

    info(text: string, delay?: number, actionText?: string): any {
        this.toast = this.success(
            text,
            delay,
            actionText,
            "md-info-toast-theme"
        );
        return this.toast;
    }

    snackbar(text: string, actionText?: string): any {
        this.toast = this.success(
            text,
            false,
            actionText,
            "md-info-toast-theme"
        );
        return this.toast;
    }

    sticky(text: string, link: string, linkText: string): void {
        let button = "";
        if (link) {
            linkText = linkText ? linkText : "View";
            button =
                "<md-button href='" + link + "'>" + linkText + "</md-button>";
        }

        this.toast = this.$mdToast.show({
            template:
                '<md-toast class="md-toast md-success-toast-theme">' +
                "<div layout='row'>" +
                "<p>" +
                text +
                "</p>" +
                button +
                "<md-button class='md-icon-button md-accent' ng-click='$mdToast.hide()'><md-icon>close</md-icon></md-button>" +
                "</div>" +
                "</md-toast>",
            hideDelay: false,
            position: "bottom left",
        });
        return this.toast;
    }

    action(text: string, action: any): any {
        this.toast = this.$mdToast.show(
            this.$mdToast.simple().textContent(text).action(action)
        );
        return this.toast;
    }
}

angular.module("vcHelper").service("ToastUtils", ToastUtils);
